import {Component, EventEmitter, Input, OnChanges, OnInit, Output} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {CoreSidebarService} from '../../../../@core/components/core-sidebar/core-sidebar.service';
import {AlertService} from '../../../shared/services/alert.service';
import {TextMessageService} from '../../../shared/services/text-message.service';

@Component({
    selector: 'app-add-textmessage',
    templateUrl: './add-textmessage.component.html',
    styleUrls: ['./add-textmessage.component.scss']
})
export class AddTextmessageComponent implements OnChanges {
    addTextMessageForm: FormGroup;
    inputTypePassword: any = 'password';
    submitted: any = false;
    submitting: any = false;
    @Output() valueSubmitted = new EventEmitter<any>();
    @Input() data: any;

    constructor(private _coreSidebarService: CoreSidebarService,
                private fb: FormBuilder,
                private alertService: AlertService,
                private textMessageService: TextMessageService) {
    }

    ngOnChanges(): void {
        this.refresh();
    }

    toggleSidebar(): void {
        this._coreSidebarService.getSidebarRegistry('add-text-message').toggleOpen();
    }

    refresh() {
        this.addTextMessageForm = this.fb.group({
            'student': ['', Validators.required],
            'university': ['', Validators.required],
            'message': ['', Validators.required]
        });
        if (this.data && this.data['id']) {
            this.patchForm();
        }
    }

    patchForm() {
        this.addTextMessageForm.patchValue({
            'student': (this.data && this.data['student']) ? this.data['student'] : '',
            'university': (this.data && this.data['university']) ? this.data['university'] : '',
            'message': (this.data && this.data['message']) ? this.data['message'] : ''
        });
    }

    submit() {
        this.submitted = true;
        if (!this.addTextMessageForm.valid) {
            return;
        }
        if (this.submitted) {
            const params = {
                'student': (this.addTextMessageForm.value && this.addTextMessageForm.value.student) ? this.addTextMessageForm.value.student : '',
                'university': (this.addTextMessageForm.value && this.addTextMessageForm.value.university) ? this.addTextMessageForm.value.university : '',
                'message': (this.addTextMessageForm.value && this.addTextMessageForm.value.message) ? this.addTextMessageForm.value.message : ''
            };
            this.submitting = true;
            this.textMessageService.create(params).subscribe(data => {
                if (data) {
                    this.submitting = false;
                    this.submitted = false;
                    this.valueSubmitted.emit(true);
                    this.addTextMessageForm.reset();
                    this.addTextMessageForm.patchValue({
                        'student': '',
                        'university': '',
                        'message': ''

                    });
                }
            }, error => {
                this.submitting = false;
                this.submitted = false;
                if (error && error['error'] && error['error']['errors'] && error['error'].hasOwnProperty('errors')) {
                    if (error['error']['errors'].university && error['error']['errors'].university.length > 0) {
                        this.alertService.showErrors(error['error']['errors'].university[0]);
                        return;
                    }
                    if (error['error']['errors'].email && error['error']['errors'].email.length > 0) {
                        this.alertService.showErrors(error['error']['errors'].email[0]);
                        return;
                    }
                    if (error['error']['errors'].message && error['error']['errors'].message.length > 0) {
                        this.alertService.showErrors(error['error']['errors'].message[0]);
                        return;
                    }
                }
            });
        }
    }

    update() {
        this.submitted = true;
        if (!this.addTextMessageForm.valid) {
            return;
        }
        if (this.submitted) {
            const params = {
                'student': (this.addTextMessageForm.value && this.addTextMessageForm.value.student) ? this.addTextMessageForm.value.student : '',
                'university': (this.addTextMessageForm.value && this.addTextMessageForm.value.university) ? this.addTextMessageForm.value.university : '',
                'message': (this.addTextMessageForm.value && this.addTextMessageForm.value.message) ? this.addTextMessageForm.value.message : ''
            };
            this.submitting = true;
            this.textMessageService.update(this.data['id'], params).subscribe(data => {
                this.submitting = false;
                this.submitted = false;
                this.valueSubmitted.emit(true);
            }, error => {
                this.submitting = false;
                this.submitted = false;
                if (error && error['error'] && error['error']['errors'] && error['error'].hasOwnProperty('errors')) {
                    if (error['error']['errors'].university && error['error']['errors'].university.length > 0) {
                        this.alertService.showErrors(error['error']['errors'].university[0]);
                        return;
                    }
                    if (error['error']['errors'].email && error['error']['errors'].email.length > 0) {
                        this.alertService.showErrors(error['error']['errors'].email[0]);
                        return;
                    }
                    if (error['error']['errors'].message && error['error']['errors'].message.length > 0) {
                        this.alertService.showErrors(error['error']['errors'].message[0]);
                        return;
                    }
                }
            });
        }
    }

}
